import { Text, Box, Stack } from '@ltvco/refresh-lib/theme';
import { useCurrentUserApiAccess } from '@ltvco/refresh-lib/v1';

export function ApiStatus() {
  const {
    currentApiPlanMonthlyUsageDescription,
    currentUserMonthlyReportLimits,
    isLoading,
  } = useCurrentUserApiAccess();
  const { isUnlimited, monthlyCreditsLimit, monthlyCreditsRemaining } =
    currentUserMonthlyReportLimits;

  const creditsUsed = () => {
    if (isUnlimited) {
      return null;
    }

    if (!monthlyCreditsLimit || monthlyCreditsRemaining === null) {
      return 0;
    }
    return (monthlyCreditsLimit as number) - (monthlyCreditsRemaining ?? 0);
  };

  const creditsUsedLabel = () => {
    if (isUnlimited) {
      return 'Unlimited credits used';
    }
    const limit = monthlyCreditsLimit as number;
    const used = creditsUsed() as number;
    return `${used} out of ${limit} credits used`;
  };

  if (isLoading) {
    return <Text>Loading...</Text>;
  }

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ sm: 'stretch' }}
      bgcolor="grey.100"
      borderRadius={1}
      overflow="hidden"
    >
      <Box
        sx={(theme) => ({
          flex: 1,
          py: theme.spacing(2.5),
          px: theme.spacing(3),
        })}
      >
        <Text
          variant="caption"
          color="text.secondary"
          display="block"
          sx={{ mb: 0.75, textTransform: 'none', letterSpacing: 0 }}
        >
          Current plan
        </Text>
        <Text variant="h6" fontWeight="bold" color="text.primary" mb={0}>
          {currentApiPlanMonthlyUsageDescription()}
        </Text>
      </Box>

      <Box
        sx={(theme) => ({
          width: { xs: '100%', sm: '1px' },
          minHeight: { xs: '1px', sm: 0 },
          bgcolor: theme.palette.divider,
          flexShrink: 0,
        })}
        aria-hidden
      />

      <Box
        sx={(theme) => ({
          flex: 1,
          py: theme.spacing(2.5),
          px: theme.spacing(3),
        })}
      >
        <Text
          variant="caption"
          color="text.secondary"
          display="block"
          sx={{ mb: 0.75, textTransform: 'none', letterSpacing: 0 }}
        >
          Credits used
        </Text>
        <Text
          variant="h6"
          fontWeight="bold"
          color="text.primary"
          data-cy="api-status-credits-used"
          mb={0}
        >
          {creditsUsedLabel()}
        </Text>
      </Box>
    </Stack>
  );
}
